var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.regexp.search", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/helpers/toConsumableArray", "react", "prop-types", "classnames", "../../propTypes", "./Logo", "./Menu", "./SearchMenu", "./SearchForm"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.regexp.search"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/helpers/toConsumableArray"), require("react"), require("prop-types"), require("classnames"), require("../../propTypes"), require("./Logo"), require("./Menu"), require("./SearchMenu"), require("./SearchForm"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.es6Regexp, global.keys, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.toConsumableArray, global.react, global.propTypes, global.classnames, global.propTypes, global.Logo, global.Menu, global.SearchMenu, global.SearchForm);
    global.NextMenu = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _es6Regexp2, _keys, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _toConsumableArray2, _react, _propTypes, _classnames, _propTypes2, _Logo, _Menu, _SearchMenu, _SearchForm) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _keys = _interopRequireDefault(_keys);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Logo = _interopRequireDefault(_Logo);
  _Menu = _interopRequireDefault(_Menu);
  _SearchMenu = _interopRequireDefault(_SearchMenu);
  _SearchForm = _interopRequireDefault(_SearchForm);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var closeMenus = function closeMenus() {
    (0, _toConsumableArray2.default)(global.document.querySelectorAll('.next-menu-submenu')).forEach(function (el) {
      return el.classList.remove('is-open');
    });
  };

  var NextMenu = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(NextMenu, _Component);

    var _super = _createSuper(NextMenu);

    function NextMenu(props) {
      var _this;

      (0, _classCallCheck2.default)(this, NextMenu);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeProxy", function () {
        clearTimeout(_this.resizeTimeOut);
        _this.resizeTimeOut = setTimeout(function () {
          return _this.onResize();
        }, 250);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMenuToggle", function () {
        _this.setState({
          menuIsOpen: !_this.state.menuIsOpen
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchToggle", function (event) {
        if (_this.props.searchForm) {
          event.preventDefault();
          closeMenus();

          _this.setState({
            searchIsOpen: !_this.state.searchIsOpen,
            subMenuOpen: ''
          }, _this.focusSearch);
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubMenuToggle", function (index) {
        closeMenus();

        _this.setState({
          subMenuOpen: index,
          searchIsOpen: false
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      _this.state = {
        menuIsOpen: false,
        searchIsOpen: false,
        subMenuOpen: '',
        moreMenu: [],
        highlightMenu: props.menu.highlightMenu
      };
      _this.resizeTimeOut = null;
      return _this;
    }

    (0, _createClass2.default)(NextMenu, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Manage resize and "more" menu if we have an "highlight" menu
        this.$root = this.root;

        if (this.props.menu.highlightMenu) {
          this.$logo = this.$root.querySelector('.next-menu__burger');
          this.$section = this.root.querySelector('.next-menu__section');
          this.$menu = this.$section.querySelector('.next-menu__list--highlight');
          this.$moreButton = this.$section.querySelector('.next-menu__list--more');
          this.lastWindowWidth = global.innerWidth;
          global.addEventListener('resize', this.onResizeProxy);
          this.onResizeProxy();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.props.menu.highlightMenu) {
          global.removeEventListener('resize', this.onResizeProxy);
        }
      }
    }, {
      key: "onResize",
      value: function onResize() {
        // - if we are on device larger than mobile, we can activate the "more" menu
        // - otherwise, we check if we have already a "more" menu
        //   => if yes, we put back "highlight" menu in its initial state
        var windowWidth = global.window.innerWidth;

        if (windowWidth >= 768) {
          this.rootWidth = this.$root.offsetWidth;
          this.sectionWidth = this.$section.offsetWidth;
          this.logoWidth = this.$logo.offsetWidth;
          var highlightMenuLength = this.state.highlightMenu.length;
          var moreMenuLength = this.state.moreMenu.length;
          var wasOnMobile = this.lastWindowWidth < 768;

          if (highlightMenuLength && (wasOnMobile || windowWidth <= this.lastWindowWidth)) {
            this.shrinkMenu();
          } else if (moreMenuLength && windowWidth > this.lastWindowWidth) {
            this.growMenu();
          }

          this.lastWindowWidth = windowWidth;
        } else if (this.state.moreMenu.length) {
          this.setState({
            moreMenu: [],
            highlightMenu: this.props.menu.highlightMenu
          });
        }
      }
    }, {
      key: "growMenu",
      value: function growMenu() {
        var moreMenu = this.state.moreMenu.slice(0);
        var highlightMenu = this.state.highlightMenu.slice(0); // if 1 item left in moreMenu, moreButton will disappear,
        // we add its width to the width available
        // else moreButton will stay, we remove its width from the width available

        var moreButtonWidth = this.$moreButton.offsetWidth * (moreMenu.length === 1 ? -1 : 1);

        while (moreMenu.length > 0 && this.rootWidth - moreButtonWidth - this.logoWidth - this.sectionWidth - moreMenu[0].width >= 10) {
          // move the first dropdown item to end of list
          var firstItem = moreMenu.shift();
          highlightMenu.push(firstItem); // recalc menu and moreButton widths

          this.sectionWidth += firstItem.width;
          moreButtonWidth = this.$moreButton.offsetWidth * (moreMenu.length === 1 ? -1 : 1);
        }

        this.setState({
          moreMenu: moreMenu,
          highlightMenu: highlightMenu
        });
      }
    }, {
      key: "shrinkMenu",
      value: function shrinkMenu() {
        var moreMenu = this.state.moreMenu.slice(0);
        var highlightMenu = this.state.highlightMenu.slice(0);
        var children = this.$menu.children;
        var moreButtonWidth = moreMenu.length > 0 ? this.$moreButton.offsetWidth : 0;
        var count = highlightMenu.length - 1;

        while (highlightMenu.length > 0 && this.rootWidth - this.logoWidth - this.sectionWidth - moreButtonWidth <= 10) {
          // move the last item to dropdown
          // store item width before moving it
          var lastItemWidth = children[count].offsetWidth;
          var lastItem = highlightMenu.pop();
          lastItem.width = lastItemWidth;
          moreMenu.unshift(lastItem); // recalc menu and moreButton widths

          this.sectionWidth -= lastItemWidth;
          moreButtonWidth = moreMenu.length > 0 ? this.$moreButton.offsetWidth : 0;
          count -= 1;
        }

        this.setState({
          moreMenu: moreMenu,
          highlightMenu: highlightMenu
        });
      }
    }, {
      key: "focusSearch",
      value: function focusSearch() {
        if (this.state.searchIsOpen) {
          this.$root.querySelector('.next-menu__input').focus();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            subMenuOpen = _this$state.subMenuOpen,
            moreMenu = _this$state.moreMenu,
            highlightMenu = _this$state.highlightMenu,
            menuIsOpen = _this$state.menuIsOpen,
            searchIsOpen = _this$state.searchIsOpen;
        var searchForm = this.props.searchForm;
        var _this$props$menu = this.props.menu,
            mainMenu = _this$props$menu.mainMenu,
            searchMenu = _this$props$menu.searchMenu,
            socialMenu = _this$props$menu.socialMenu;
        var _this$props$config = this.props.config,
            color = _this$props$config.color,
            colorBg = _this$props$config.colorBg,
            colorHighlight = _this$props$config.colorHighlight,
            colorSubMenu = _this$props$config.colorSubMenu,
            colorSubMenuBg = _this$props$config.colorSubMenuBg,
            colorHighlightSubMenu = _this$props$config.colorHighlightSubMenu,
            colorHighlightSubMenuBg = _this$props$config.colorHighlightSubMenuBg,
            logo = _this$props$config.logo,
            logoLabels = _this$props$config.logoLabels,
            moreLabel = _this$props$config.moreLabel,
            showMoreLabel = _this$props$config.showMoreLabel;
        var labels = this.props.labels;

        if (!labels || (0, _keys.default)(labels).length === 0) {
          labels = {
            logo: logoLabels,
            more: {
              label: moreLabel,
              show: showMoreLabel
            }
          };
        }

        var ariaMenuProps = {
          'aria-label': labels.menu ? labels.menu.label : undefined
        };
        return /*#__PURE__*/_react.default.createElement("nav", (0, _extends2.default)({}, ariaMenuProps, {
          className: (0, _classnames.default)('next-menu', {
            'is-expanded': menuIsOpen
          }),
          style: {
            backgroundColor: colorBg
          },
          ref: this.init
        }), /*#__PURE__*/_react.default.createElement(_Logo.default, {
          logo: logo,
          labels: labels.logo,
          onMenuToggle: this.onMenuToggle,
          menuIsOpen: menuIsOpen,
          textColor: colorSubMenu
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "next-menu__section"
        }, mainMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, {
          className: "next-menu__list--main",
          links: mainMenu,
          menuColor: color,
          menuIndex: 0,
          onSubMenuToggle: this.onSubMenuToggle,
          subMenuOpen: subMenuOpen,
          subMenuStyle: {
            color: colorSubMenu,
            colorBg: colorSubMenuBg
          }
        }), mainMenu && highlightMenu && /*#__PURE__*/_react.default.createElement("span", {
          className: "next-menu__separator"
        }), highlightMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, {
          className: "next-menu__list--highlight",
          links: highlightMenu,
          menuColor: colorHighlight,
          menuIndex: 1,
          onSubMenuToggle: this.onSubMenuToggle,
          subMenuOpen: subMenuOpen,
          subMenuStyle: {
            color: colorHighlightSubMenu,
            colorBg: colorHighlightSubMenuBg
          }
        }), this.props.menu.highlightMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, {
          className: (0, _classnames.default)('next-menu__list--more', {
            'is-visible': moreMenu.length > 0
          }),
          links: [{
            label: labels.more.label || 'More',
            subLabel: labels.more.show || 'show other links menu',
            subMenu: moreMenu
          }],
          menuColor: colorHighlight,
          menuIndex: 2,
          onSubMenuToggle: this.onSubMenuToggle,
          subMenuOpen: subMenuOpen,
          subMenuStyle: {
            color: colorHighlightSubMenu,
            colorBg: colorHighlightSubMenuBg
          }
        }), (mainMenu || highlightMenu) && socialMenu && /*#__PURE__*/_react.default.createElement("span", {
          className: "next-menu__separator"
        }), socialMenu && /*#__PURE__*/_react.default.createElement(_Menu.default, {
          className: "next-menu__list--social",
          links: socialMenu,
          menuIndex: 3
        }), (mainMenu || highlightMenu || socialMenu) && searchMenu && /*#__PURE__*/_react.default.createElement("span", {
          className: "next-menu__separator next-menu__separator--search"
        }), searchMenu && /*#__PURE__*/_react.default.createElement(_SearchMenu.default, {
          className: "next-menu__list--search",
          links: searchMenu,
          onSearchToggle: this.onSearchToggle,
          isLink: !searchForm,
          searchIsOpen: searchIsOpen
        }), searchForm && /*#__PURE__*/_react.default.createElement(_SearchForm.default, {
          searchForm: searchForm,
          searchIsOpen: searchIsOpen,
          labels: labels.search
        })));
      }
    }]);
    return NextMenu;
  }(_react.Component);

  var linkPropType = _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    subLabel: _propTypes.default.string,
    href: _propTypes.default.string.isRequired,
    attr: _propTypes.default.shape({
      class: _propTypes.default.string,
      title: _propTypes.default.string
    }),
    subMenu: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      href: _propTypes.default.string.isRequired
    }))
  });

  NextMenu.propTypes = {
    config: _propTypes.default.shape({
      color: _propTypes.default.string,
      colorBg: _propTypes.default.string,
      colorHighlight: _propTypes.default.string,
      colorSubMenu: _propTypes.default.string,
      colorSubMenuBg: _propTypes.default.string,
      colorHighlightSubMenu: _propTypes.default.string,
      colorHighlightSubMenuBg: _propTypes.default.string,
      logo: _propTypes.default.shape({
        path: _propTypes.default.string,
        href: _propTypes.default.string,
        label: _propTypes.default.string
      }),
      logoLabels: _propTypes2.default.deprecated(_propTypes.default.shape({
        showMenu: _propTypes.default.string
      }), 'Please use labels.logo instead of this prop'),
      moreLabel: _propTypes2.default.deprecated(_propTypes.default.string, 'Please use labels.more.label instead of this prop'),
      showMoreLabel: _propTypes2.default.deprecated(_propTypes.default.string, 'Please use labels.more.show instead of this prop')
    }),
    menu: _propTypes.default.shape({
      mainMenu: _propTypes.default.arrayOf(linkPropType),
      highlightMenu: _propTypes.default.arrayOf(linkPropType),
      socialMenu: _propTypes.default.arrayOf(linkPropType),
      searchMenu: _propTypes.default.arrayOf(linkPropType)
    }),
    searchForm: _propTypes.default.shape({
      callback: _propTypes.default.func,
      placeholder: _propTypes.default.string
    }),
    labels: _propTypes.default.shape({
      menu: _propTypes.default.shape({
        label: _propTypes.default.string
      }),
      logo: _propTypes.default.shape({
        showMenu: _propTypes.default.string
      }),
      more: _propTypes.default.shape({
        label: _propTypes.default.string,
        show: _propTypes.default.string
      }),
      search: _propTypes.default.shape({
        input: _propTypes.default.string,
        submit: _propTypes.default.string,
        search: _propTypes.default.string
      })
    })
  };
  NextMenu.defaultProps = {
    config: {
      color: '#ff5733',
      colorBg: 'white',
      colorHighlight: '#c70039',
      colorSubMenu: 'black',
      colorSubMenuBg: 'white',
      colorHighlightSubMenu: 'black',
      colorHighlightSubMenuBg: 'white',
      logo: {},
      moreLabel: 'More',
      showMoreLabel: 'show other links menu'
    },
    menu: {}
  };
  var _default = NextMenu;
  _exports.default = _default;
});